/**
 * Futures nav submenu (UserHeader + AuthHeader).
 * Icons: `public/images/futures_menu_*.svg` — add your line-art assets there.
 */
export const FUTURES_SUBMENU_ITEMS = [
  {
    id: "usds_m",
    title: "USDT-M Futures",
    desc: "Trade futures settled in USDT",
    to: "/futures_trade/BTC_USDT",
    iconSrcDark: "/images/usd_icon_menu.svg",
    iconSrcLight: "/images/usd_icon_menu_light.svg",
  },
  // {
  //   id: "coin_m",
  //   title: "COIN-M Futures",
  //   desc: "Trade futures settled in cryptocurrency",
  //   // to: "/coming_soon",
  //   to: "/futures_trade/BTC_USDT",
  //   iconSrc: "/images/cossmargin_icon.svg",
  // },
  {
    id: "options",
    title: "Options",
    desc: "Zero fees with direct user-to-user transactions",
    to: "/options/BTC_USDT",
    iconSrcDark: "/images/convert_icon_menu.svg",
    iconSrcLight: "/images/convert_icon_menu_light.svg",
  },
];
